<section class="sbnb-onboarding">
  <sbnb-signup-header></sbnb-signup-header>

  <article class="main">
    <header>
      <h2 class="nomargin">Create your password</h2>
    </header>
    <section class="content">
      <p></p>
      <form [formGroup]="formGroup">
        <label for="password">Password</label>
        <mat-form-field fxFlex>
          <input
            matInput
            name="password"
            placeholder="Min 8 characters"
            formControlName="password"
            autocomplete="off"
            type="password" />
          <mat-error *ngIf="formGroup.controls.password.hasError('required')">Password is required</mat-error>
          <mat-error *ngIf="formGroup.controls.password.hasError('minlength')">
            Password must be at least 8 characters
          </mat-error>
        </mat-form-field>

        <label for="confirm">Password check</label>
        <mat-form-field fxFlex>
          <input
            matInput
            name="confirm"
            placeholder="Repeat password"
            formControlName="confirm"
            autocomplete="off"
            type="password" />
          <mat-error *ngIf="formGroup.controls.password.valid && formGroup.controls.confirm.hasError('mismatch')">
            The passwords don’t match.
          </mat-error>
        </mat-form-field>
        <button mat-flat-button mat-primary [disabled]="saving" submit="true" class="next-step" (click)="next()">
          <mat-spinner *ngIf="saving" class="button__spinner" [diameter]="30"></mat-spinner>
          Continue
        </button>
      </form>
    </section>
  </article>

  <aside>
    <img src="/assets/images/signup/password.svg" />
  </aside>
</section>
